export default __webpack_public_path__ + "static/media/vector_bg.f460bd27.svg";